import React from "react";
import Hero from "../components/Hero";
import ProductShowcase from "../components/ProductShowcase";
import LifestyleEditorial from "../components/LifestyleEditorial";
import BenefitsAccordion from "../components/BenefitsAccordion";
import FeaturedProducts from "../components/FeaturedProducts";
import Testimonials from "../components/Testimonials";
import FinalCTA from "../components/FinalCTA";

const Home = () => {
  return (
    <main>
      <Hero />
      <ProductShowcase />
      <LifestyleEditorial />
      <BenefitsAccordion />
      <FeaturedProducts />
      <Testimonials />
      <FinalCTA />
    </main>
  );
};

export default Home;
